import { render, staticRenderFns } from "./RoleView.vue?vue&type=template&id=138b23d4&scoped=true"
import script from "./RoleView.vue?vue&type=script&lang=js"
export * from "./RoleView.vue?vue&type=script&lang=js"
import style0 from "./RoleView.vue?vue&type=style&index=0&id=138b23d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138b23d4",
  null
  
)

export default component.exports